var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 13,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M5 5.977A1.333 1.333 0 1 0 5 3.31a1.333 1.333 0 0 0 0 2.667"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  fillRule: "evenodd",
  d: "M5 12.75c2.496-1.67 4.935-4.356 4.935-7.526C9.935 2.555 7.665.25 4.994.25 2.32.25.065 2.558.065 5.224c0 3.171 2.44 5.855 4.935 7.525M1.4 5.223c0-1.946 1.674-3.64 3.595-3.64 1.924 0 3.608 1.696 3.608 3.64 0 2.403-1.794 4.493-3.602 5.896C3.192 9.717 1.4 7.627 1.4 5.224",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#474747",
  d: "M6.334 4.644a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0"
})));
export default SvgLocationPin;